import React, { useEffect, useState } from 'react';
import { KakoCoin } from '../oil/OilIcons';
import { fmt } from './wbApi';
import { wbSfx } from './wbSfx';

const DURACAO = 7000;
const MOEDAS = Array.from({ length: 18 }, (_, i) => ({ x: (i * 53) % 100, d: (i % 6) * 0.35, s: 0.8 + (i % 4) * 0.15 }));

/* Chuva de Vencedores: faixa dourada + moedas caindo sobre a cena quando alguém leva o balão de 50.000. */
export const WbGoldenRain = ({ win, onDone }) => {
  const [shown, setShown] = useState(null);
  useEffect(() => {
    if (!win) return undefined;
    setShown(win);
    wbSfx.coin();
    const t = setTimeout(() => { setShown(null); onDone?.(); }, DURACAO);
    return () => clearTimeout(t);
  }, [win, onDone]);
  if (!shown) return null;
  return (
    <div className="wb-rain pointer-events-none absolute inset-0 z-30 overflow-hidden" data-testid="wb-golden-rain">
      {MOEDAS.map((m, i) => (
        <KakoCoin key={i} className="wb-rain-coin absolute -top-10 h-7" style={{ left: `${m.x}%`, animationDelay: `${m.d}s`, transform: `scale(${m.s})` }} />
      ))}
      <div className="wb-rain-banner absolute inset-x-3 top-[18%] rounded-2xl border-2 border-amber-200 bg-gradient-to-r from-amber-600 via-yellow-400 to-amber-600 px-3 py-2 text-center shadow-[0_0_40px_rgba(251,191,36,.9)]">
        <p className="text-[9px] font-black uppercase tracking-[.3em] text-amber-950">balão dourado estourado!</p>
        <div className="flex items-center justify-center gap-2">
          {shown.avatar && <img src={shown.avatar} alt="" className="h-7 w-7 rounded-full border-2 border-amber-100 object-cover" />}
          <p className="text-[13px] font-black leading-tight text-amber-950" data-testid="wb-golden-rain-text">
            {shown.nickname}<br /><span className="text-base">levou {fmt(shown.prize)} moedas</span>
          </p>
        </div>
      </div>
    </div>
  );
};
